import React from "react";

export default props => {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" {...props}>
            <path fill="#FFF" d="M1.556 0C.696 0 0 .696 0 1.556h1.556V0zM3.11 0v1.556h1.556V0H3.11zm3.111 0v1.556h1.556V0H6.222zm3.111 0v1.556h1.556V0H9.333zm3.111 0v1.556H14C14 .696 13.304 0 12.444 0zM0 3.111v1.556h1.556V3.11H0zm12.444 0v1.556H14V3.11h-1.556zM7 4.667L5.962 6.222H4.278c-.644 0-1.167.523-1.167 1.167v5.444c0 .644.523 1.167 1.167 1.167h8.555c.644 0 1.167-.523 1.167-1.167V7.39c0-.644-.523-1.167-1.167-1.167H11.15l-1.04-1.556H7zM0 6.222v1.556h1.556V6.222H0zm8.556 1.556a2.333 2.333 0 110 4.666 2.333 2.333 0 010-4.666zM0 9.333v1.556h1.556V9.333H0zm0 3.111C0 13.304.696 14 1.556 14v-1.556H0z"></path>
        </svg>
    );
}